const routes = {
  login: '/',
  signup: '/signup',
  otpverification: '/otpverification',
  forgotPassword: '/forgotpassword',
  changePassword: '/changePassword',
  dashboard: '/home',
  emailverification: '/emailverification',
  pendingAction: '/pending/action',
  faqs: '/faqs',
  viewAll: '/viewall',
  forum: '/forum',
  forumDetails: '/formdetails',
  instruction: "/instruction",
  completefaq: "/Faq"
};

export default routes;
